export default __webpack_public_path__ + "static/media/logo.565f7f2c.svg";